module.exports = __webpack_public_path__ + "img/media-ig.7232f006.png";